import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Check from '../../svg/Check.jsx'
import { isNil } from 'ramda'
import { v4 as uuidV4 } from 'uuid'

const CheckBox = ({
    defaultChecked,
    defaultValue,
    label,
    extraLabel = '',
    description,
    size = 'small',
    correctValue,
    onChange,
    disabled = false,
    variant = 'white',
    isGroup = false,
    className,
}) => {
    const [checked, setChecked] = useState(defaultChecked)
    const customSizeCheck = size === 'large' ? 'w-6 h-6' : 'w-4 h-4'
    const customSizeIcon = size === 'large' ? 'w-3.5 h-3.5' : 'w-2.25 h-1.75'
    const isBlack = variant === 'black'

    useEffect(() => {
        setChecked(defaultChecked)
    }, [defaultChecked])

    const toggleChecked = () => {
        if ((!defaultChecked && isGroup) || !isGroup) {
            if (checked) {
                onChange(defaultValue)
            } else {
                onChange(correctValue)
            }
            setChecked(!checked)
        }
    }

    return (
        <div
            className={clsx(
                'relative flex items-center justify-start',
                className,
            )}
        >
            <div className="flex items-center">
                <div
                    id={label || uuidV4()}
                    onClick={!disabled ? toggleChecked : null}
                    className={clsx(
                        'cursor-pointer flex items-center justify-center border rounded-2.5',
                        { ['bg-textDarkerGray border-none']: checked },
                        customSizeCheck,
                        isBlack
                            ? 'bg-black60 border-black60'
                            : 'bg-white border-grayLines',
                    )}
                >
                    {checked && (
                        <Check
                            color={isBlack ? '#FFC20D' : 'white'}
                            className={clsx(
                                'stroke-2 select-none',
                                customSizeIcon,
                            )}
                        />
                    )}
                </div>
            </div>
            {(!isNil(description) || !isNil(label)) && (
                <div className="ml-2">
                    {label && (
                        <div
                            onClick={!disabled ? toggleChecked : null}
                            className="flex space-x-2"
                        >
                            <label
                                className={clsx(
                                    'font-normal text-sm transition-all',
                                    !isBlack && 'text-textDarkerGray',
                                    isBlack && checked && 'text-white',
                                    isBlack && !checked && 'text-black30',
                                )}
                            >
                                {label}
                            </label>
                            {extraLabel && (
                                <label className="font-normal text-sm transition-all text-textDarkGray">
                                    {` (${extraLabel})`}
                                </label>
                            )}
                        </div>
                    )}
                    {description && (
                        <p className="text-textDarkGray font-normal text-xs">
                            {description}
                        </p>
                    )}
                </div>
            )}
        </div>
    )
}

CheckBox.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    extraLabel: PropTypes.string,
    description: PropTypes.string,
    size: PropTypes.string,
    correctValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.number,
        PropTypes.object,
    ]),
    onChange: PropTypes.func,
    defaultChecked: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.number,
        PropTypes.object,
    ]),
    defaultValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.number,
        PropTypes.object,
    ]),
    variant: PropTypes.string,
    isGroup: PropTypes.bool,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
}

export default CheckBox
